export default {
    'youtube': {
        link: 'http://www.youtube.com/c/Ответ',
        label: 'Otvet youtube channel'
    },
    'telegram': {
        link: 'https://t.me/OtvetCo',
        label: 'Otvet telegram'
    },
    'podcast': {
        link: 'https://podcasts.apple.com/ru/podcast/otvet-co/id1488897817',
        label: 'Otvet apple podcast'
    }
}

